import Axios from 'axios';
import Cookies from 'js-cookie';
import { getCSRFToken as getCSRFTokenService } from '@/services';

const getCSRFTokenFromCookie = () => Cookies.get('csrf_token_v2');

const requestMap = {};

let onAuthExpire = () => {};

const isInvalidCSRF = (param = {code: 0, message: ''}) => ((param.code === 403) && (param.message === 'Invalid CSRF token'));

export const cancelRequest = (apiKey) => {
  if (apiKey && requestMap[apiKey] && typeof requestMap[apiKey].cancel === 'function') {
    requestMap[apiKey].cancel();
    delete requestMap[apiKey];
  }
};

export const request = (apiKey, func, csrfToken) => {
  cancelRequest(apiKey);

  const cancelToken = Axios.CancelToken;
  const source = cancelToken.source();

  requestMap[apiKey] = source;
  return func(source.token, csrfToken).then(({
    data = {},
    status,
  }) => {
    delete requestMap[apiKey];
    if (data.data) {
      return data.data;
    } else if (status === 204) {
      return data;
    }
    throw data.error || data;
  }).catch((error) => {
    delete requestMap[apiKey];
    if ((error.code === 401 || isInvalidCSRF(error)) && apiKey.indexOf('[ignore]') < 0) {
      onAuthExpire();
      throw error;
    }
    if (error instanceof Axios.Cancel) {
      return new Promise(() => {});
    }
    throw error;
  });
};


export const getCSRFToken = () => {
  const csrfToken = getCSRFTokenFromCookie();
  if (csrfToken) {
    return Promise.resolve(csrfToken);
  }

  return request('getCSRFToken', getCSRFTokenService.bind(null, null))
    .then(() => {
      const csrfTokenT = Cookies.get('csrf_token_v2');
      if (csrfTokenT) {
        return csrfTokenT;
      }
      throw Error;
    });
};

export const requestWithToken = (apiKey, func) => (
  getCSRFToken().then(() => request(apiKey, func, Cookies.get('csrf_token_v2')))
);

export const setOnAuthExpire = (cb) => {
  onAuthExpire = cb;
};

export const resetCsrfToken = () => {
  Cookies.remove('csrf_token_v2');
};

export const generateFilterParam = (filters) => {
  const arr = [];
  if (filters) {
    Object.keys(filters).forEach((k) => filters[k] && arr.push(`${k}:${filters[k]}`));
  }

  if (arr.length) {
    return arr.join(',');
  }
  return '';
};

export default {
  request,
  requestWithToken,
  cancelRequest,
};
